import { SecureRoute } from '@okta/okta-react';
import { Moment } from 'moment';
import React, { FC, useEffect } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import styled from 'styled-components';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { NotFound } from 'components/atoms/result';
import { Page as PageAtom } from 'components/molecules/page';
import { mondayOfWeek } from 'components/organisms/timesheets/common/utils';
import { Timesheet } from 'components/organisms/timesheets/types';
import {
  TimesheetApprovalAllUserPage,
  TimesheetApprovalSingleUserPage,
} from 'components/pages/timesheet';

const Page = styled(PageAtom)`
  justify-content: center;
`;

export const TimesheetApprovalsRoutes: FC<{
  configuration: Configuration;
  startDate: Moment;
  onStartDateChange: (value: Moment) => void;
  onTimesheetStateChange: (
    userId: number,
    payload: Partial<Omit<Timesheet, 'userId'>>,
  ) => void;
  timesheets: Timesheet[];
  pendingApprovalCount: number;
  refreshData: () => void;
  hasApprovalTabPermission: boolean;
  isTimesheetLoading: boolean;
}> = ({
  configuration,
  startDate,
  onStartDateChange,
  timesheets,
  onTimesheetStateChange,
  pendingApprovalCount,
  refreshData,
  hasApprovalTabPermission,
  isTimesheetLoading,
}) => {
  const { path } = useRouteMatch();

  useEffect(() => {
    return () => {
      onStartDateChange(mondayOfWeek());
    };
  }, [onStartDateChange]);

  return hasApprovalTabPermission || isTimesheetLoading ? (
    <Switch>
      <SecureRoute path={`${path}/:userId`}>
        <TimesheetApprovalSingleUserPage
          configuration={configuration}
          startDate={startDate}
          onStartDateChange={onStartDateChange}
          refreshTimesheetData={refreshData}
          approvees={timesheets.map((timesheet) => timesheet.userId)}
          isUserTimesheetsLoading={isTimesheetLoading}
        />
      </SecureRoute>
      <SecureRoute path={path}>
        <TimesheetApprovalAllUserPage
          configuration={configuration}
          startDate={startDate}
          onStartDateChange={onStartDateChange}
          timesheets={timesheets}
          pendingApprovalCount={pendingApprovalCount}
          onTimesheetStateChange={onTimesheetStateChange}
          refreshData={refreshData}
          isTimesheetLoading={isTimesheetLoading}
        />
      </SecureRoute>
    </Switch>
  ) : (
    <Page>
      <NotFound />
    </Page>
  );
};
